import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import Add from "../../assets/assets/add-staff.svg";
import { logOut } from "../../redux/Actions/LoginActions";
import {
  uploadReset,
  getAllStaffs,
  resetUser,
  deleteStaff,
} from "../../redux/Actions/SingleUserActions";
import StaffActions from "./StaffActions";
import Storage from "../../utils/storage";
import Search from "../../assets/assets/search.svg";
import Spinner from "react-spinner-material";
import Alert from "../../utils/Alert";
import UserModal from "../../components/EmailModal/UserModal";
import ReactPaginate from "react-paginate";
import { searchStaff } from "../../redux/Actions/FilterActions";
import { PropTypes } from "prop-types";

export const AddStaff = ({
  resetUser,
  isGetting,
  staffs,
  getAllStaffs,
  deleteStaff,
  isDeleting,
  deleteSuccess,
  searchStaffSuccess,
  searchedStaff,
  isSearching,
  searchStaff,
  logOut,
  error,
}) => {
  const [state, setState] = useState({
    showModal: false,
    hideModal: true,
    showEditModal: false,
    hideEditModal: true,
    showDeleteModal: false,
    hideDeleteModal: true,
    staff: {},
    staff_first_name: "",
    staff_last_name: "",
    staff_id_no: "",
    selected: 0,
    offset: 0,
    showResults: false,
    searchedValue: "",
    search: "",
    isMobile: false,
  });

  let userToken = Storage.get("user-access-token");

  useEffect(() => {
    if (error && error.data && error.data.suspension_note) {
      const payload = {
        access_token: userToken
      }
      logOut(payload)
    }
  }, [error, userToken, logOut]);

  useEffect(() => {
    setState({
      showResults: false,
      searchedValue: "",
      offset: 0,
    });
    let offset = 0;
    let limit = 10;
    resetUser();
    getAllStaffs(offset, limit);
  },
  // eslint-disable-next-line
  [resetUser, getAllStaffs]);

  useEffect(
    () => {
      if (searchStaffSuccess) {
        setState({
          showResults: true,
          offset: state.offset,
        });
      }
    },
    // eslint-disable-next-line
    [searchStaffSuccess]
  );

  const data = (() => {
    if (!state.showResults) {
      return staffs.data;
    } else {
      return searchedStaff.data;
    }
  })();

  const showModal = () => {
    setState({
      ...state,
      showModal: true,
    });
  };

  const hideModal = () => {
    document.getElementById("signform").reset();
    setState({
      ...state,
      hideModal: true,
      showModal: false,
    });
  };

  const hideEditModal = () => {
    setState({
      ...state,
      hideEditModal: true,
      showEditModal: false,
    });
  };

  const showDeleteModal = (index) => {
    const selected = data && data.findIndex((_, ind) => ind === index);
    setState({
      ...state,
      staff: data[selected],
      showDeleteModal: true,
      staff_first_name: data[selected] && data[selected].first_name,
      staff_last_name: data[selected] && data[selected].last_name,
      staff_id_no: data[selected] && data[selected].id,
    });
  };

  const hideDeleteModal = () => {
    setState({
      ...state,
      hideDeleteModal: true,
      showDeleteModal: false,
    });
  };

  useEffect(
    () => {
      if (deleteSuccess) {
        Alert(true, "success", "Success message", "Staff successfully deleted.");
        hideDeleteModal();
        uploadReset();
        resetUser();
        let offset = 0;
        let limit = 10;
        getAllStaffs(offset, limit);
      }
    },
    // eslint-disable-next-line
    [deleteSuccess]
  );

  const dataLength = (() => {
    if (state.showResults) {
      return (
        searchedStaff &&
        searchedStaff.totalCount &&
        parseInt(searchedStaff.totalCount)
      );
    } else {
      return staffs && staffs.totalCount && parseInt(staffs.totalCount);
    }
  })();

  const pageCount = Math.ceil(parseInt(dataLength) / 10);

  const handlePageClick = (data) => {
    let limit = 10;
    let selected = data.selected;
    let offset = Math.ceil(selected * 10);
    setState({
      ...state,
      selected: data.selected,
      offset: offset,
      search: state.searchedValue,
    });
    if (!state.showResults) {
      getAllStaffs(offset, limit);
    } else {
      const search = Storage.get("search-value");
      searchStaff(search, limit, offset);
    }
  };

  const checkKey = (e) => {
    if (e.key === "Enter") {
      searchItems();
    }
  };

  const onSearch = (event) => {
    setState({
      searchedValue: event.target.value,
      offset: state.offset,
      search: state.searchedValue,
    });
  };

  const searchItems = () => {
    if (state.searchedValue === "") {
      return staffs && staffs.data;
    } else {
      let search = state.searchedValue;
      let limit = 10;
      let offset = 0;
      searchStaff(search, limit, offset);
      Storage.set("search-value", state.searchedValue);
    }
  };

  const sortedStaffs = (() => {
    if (!state.showResults) {
      return staffs && staffs.data;
    } else {
      return searchedStaff && searchedStaff.data;
    }
  })();

  const totalStaffDisplayed = (data && data.length) + state.offset;

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body-staff">
        <div className="staff-button">
          <button data-testid="showmodal" onClick={showModal}>
            <img src={Add} alt="add" />
            ADD NEW STAFF
          </button>
        </div>

        <div className="staff-header">
          <div className="staff-header-left">
            <h2>Staff Management</h2>
            {(!isGetting || !isSearching) && data && data.length > 0 && (
              <p>
                <span>{totalStaffDisplayed}</span> of <span>{dataLength}</span>{" "}
                staff
              </p>
            )}
          </div>
          <div className="staff-header-right">
            <div className="input-container">
              <input
                type="text"
                placeholder="Search"
                onChange={onSearch}
                value={state.searchedValue}
                onKeyDown={checkKey}
              />
              <div
                data-testid="searchItems"
                className="search-icon"
                onClick={() => searchItems()}
              >
                <img src={Search} alt="search" />
              </div>
            </div>
          </div>
        </div>

        <StaffActions
          showModal={state.showModal}
          hideModal={hideModal}
          showEditModal={state.showEditModal}
          hideEditModal={hideEditModal}
          firstName={state.staff && state.staff.first_name}
          lastName={state.staff && state.staff.last_name}
          staffEmail={state.staff && state.staff.email}
          staffPassword={state.staff && state.staff.password}
          staffId={state.staff && state.staff.id}
        />

        <div className="tables">
          <table>
            <thead>
              <tr>
                <td className="id">S/N</td>
                <td className="title">Name</td>
                <td className="email">Email</td>
                <td>Status</td>
                <td className="view">Actions</td>
              </tr>
            </thead>

            {isGetting || isSearching ? (
              <div className="center-spinner">
                <Spinner
                  size={120}
                  color={"#047558"}
                  spinnerwidth={5}
                  visible={true}
                />
              </div>
            ) : (
                <tbody>
                  {sortedStaffs && sortedStaffs.length === 0 ? (
                    <div className="dashboard-main-content empty2">
                      <p>No Staff Found</p>
                    </div>
                  ) : (
                      sortedStaffs &&
                      sortedStaffs.map((user, index) => {
                        return (
                          <tr key={Math.random()}>
                            <td className="id">
                              <p>S/N</p> {state.offset + index + 1}
                            </td>
                            <td className="title">
                              <p>Name</p>
                              <div>
                                {user.first_name} {user.last_name}
                              </div>
                            </td>
                            <td className="email">
                              <p>Email</p> <div>{user.email}</div>
                            </td>
                            <td>
                              <p>Status</p> <div>Active</div>
                            </td>
                            <td className="view">
                              <p>Actions</p>
                              <div className="view-wrapper">
                                <h5>
                                  Delete <span>Staff</span>
                                </h5>
                                <div className="view-buttons">
                                  {/* <button
                                    data-testid="showEditModal"
                                    onClick={() => showEditModal(index)}
                                  >
                                    Update
                              </button> */}
                                  <button
                                    data-testid="showDeleteModal"
                                    style={{ backgroundColor: "#FF3D3D" }}
                                    onClick={() => showDeleteModal(index)}
                                  >
                                    Delete
                              </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}

                  {(!isGetting || isSearching) && dataLength > 10 && (
                    <ReactPaginate
                      previousLabel={"prev"}
                      nextLabel={"next"}
                      breakClassName={"break-me"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      subContainerClassName={"pages pagination"}
                      activeClassName={"active"}
                      perPage={10}
                      forcePage={state.selected}
                    />
                  )}
                </tbody>
              )}
          </table>
        </div>
      </main>

      <UserModal
        open={state.showDeleteModal}
        close={hideModal}
        height={"400"}
        width={"500"}
      >
        <div className="modal-header">
          <h1>DELETE STAFF</h1>
        </div>

        <p className="confirm-delete">
          You are about to delete {state.staff_first_name}{" "}
          {state.staff_last_name} from your staff list?
        </p>

        <div className="modal-form">
          <div className="form-grid-4">
            <div className="modal-input-button">
              <button className="modal-close-button" type="button" onClick={hideDeleteModal}>
                CANCEL
              </button>
            </div>

            <div className="modal-input-button">
              <button
                type="submit"
                className="modal-action-button"
                disabled={isDeleting}
                onClick={() => deleteStaff(state.staff_id_no)}
              >
                CONFIRM
              </button>
            </div>
          </div>
        </div>
      </UserModal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadReset: () => dispatch(uploadReset()),
  getAllStaffs: (offset, limit) => dispatch(getAllStaffs(offset, limit)),
  resetUser: () => dispatch(resetUser()),
  deleteStaff: (id) => dispatch(deleteStaff(id)),
  searchStaff: (search, limit, offset) =>
    dispatch(searchStaff(search, limit, offset)),
  logOut: (payload) => dispatch(logOut(payload)),
});

const mapStateToProps = (state) => ({
  isGetting: state.singleStaff.isGettingAllStaff,
  staffs: state.singleStaff.allStaff,
  isDeleting: state.singleStaff.isDeleting,
  deleteSuccess: state.singleStaff.deleteSuccess,
  searchStaffSuccess: state.filters.searchStaffSuccess,
  searchedStaff: state.filters.searchedStaff,
  isSearching: state.filters.isSearching,
  error: state.docs.error,
});

AddStaff.propTypes = {
  deleteStaff: PropTypes.func,
  deleteSuccess: PropTypes.bool,
  error: PropTypes.object,
  getAllStaffs: PropTypes.func,
  isDeleting: PropTypes.bool,
  isGetting: PropTypes.bool,
  isSearching: PropTypes.bool,
  logOut: PropTypes.func,
  resetUser: PropTypes.func,
  searchStaff: PropTypes.func,
  searchStaffSuccess: PropTypes.bool,
  searchedStaff: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.any, PropTypes.any]),
  staffs: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.any, PropTypes.any])
}

export default connect(mapStateToProps, mapDispatchToProps)(AddStaff);
